import { useSyncExternalStore } from "react";

type UpdateAction = () => Promise<void>;
let updateAction: UpdateAction | null = null;
const listeners = new Set<() => void>();

export function showAppUpdate(action: UpdateAction) {
  updateAction = action;
  listeners.forEach((listener) => listener());
}

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => { listeners.delete(listener); };
};
const getSnapshot = () => updateAction;

// Registration starts before React mounts; retain updates until the UI subscribes.
export function useAppUpdate() {
  return useSyncExternalStore(subscribe, getSnapshot);
}
